jQuery(document).ready(function ($) {

    $(".bloc_offres").each(function () {
        var $bloc = $(this);
        var $btns = $bloc.find('.offre-filtre');
        var $cards = $bloc.find('.offre-card');
        var $count = $bloc.find('.offres-count-nb');

        $btns.on('click', function () {
            $btns.removeClass('active');
            $(this).addClass('active');

            var filtre = $(this).data('filtre');
            var visible = 0;

            $cards.each(function () {
                if (!filtre || $(this).data('entreprise') === filtre) {
                    $(this).show();
                    visible++;
                } else {
                    $(this).hide();
                }
            });

            $count.text(visible);
        });
    });

});
